/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Scroll_To_ZoomInputs */



/**
* | output |
* | --- |
* | "Scroll to Zoom" |
*
* @param {Options_Editor_Scroll_To_ZoomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_scroll_to_zoom = /** @type {((inputs?: Options_Editor_Scroll_To_ZoomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Scroll_To_ZoomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "es") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Scroll to Zoom")
	return /** @type {LocalizedString} */ ("Scroll to Zoom")
});